import { Components, Theme } from "@mui/material";

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  styleOverrides: {
    tooltip: {
      fontSize: 11,
    },
  },
};
